import React, { useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { TextField } from '@material-ui/core';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/JudgementAdd/messages';
import { RefusalDialogWrapper } from 'containers/CourtManagerLegalProceedings/JudgementAdd/styled-components';
import { get } from 'lodash';
import { PROCEDURE_STATUSES } from 'containers/data-structure';
import { toast } from 'react-toastify';
import { pushTo } from 'containers/services/routes-helper';
import { PAGES } from 'routes';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';

export interface RejectionDialogProps {
  intl: IntlShape;
  isRejectionDialogOpen: boolean;
  setIsRejectionDialogOpen: Function;
  updateContestation?: Function;
  lawyer: string;
  claimId?: number;
  claimNumber?: string;
  jom: any;
  isAppeal?: boolean;
  setJomStatus?: Function;
  validator?: string;
}

export const RejectionDialog: React.FC<RejectionDialogProps> = (
  props,
): JSX.Element => {
  const [rejectionReason, setRejectionReason] = useState<string>('');

  /* istanbul ignore next */
  const handleChangeRejectionReason = (
    event: React.ChangeEvent<{
      value: string;
    }>,
  ) => setRejectionReason(event.target.value);

  /* istanbul ignore next */
  const handleValidation = () => {
    if (props.updateContestation)
      props.updateContestation(
        get(props.jom, 'jom.jmc.id'),
        get(props.jom, 'jom.jmc.hearingDate'),
        get(props.jom, 'jom.jmc.lawyerOpinion'),
        get(props.jom, 'claimId'),
        get(props.jom, 'procedureType'),
        get(props.jom, 'judiciaryProcessId'),
        props.validator,
        PROCEDURE_STATUSES.REJECTED,
        get(props.jom, 'claimNumber'),
        false,
        false,
        handleSuccessCallback,
        rejectionReason,
      );
  };

  /* istanbul ignore next */
  const handleSuccessCallback = () => {
    toast.success(
      translate(messages.courtManagerRefusalDialogSuccessMessage, props, {
        lawyer: props.lawyer,
      }),
    );
    props.setIsRejectionDialogOpen(false);
    if (!featureService.hasFeature(FEATURES.EVOLUTIONS_FEE_NOTE)) {
      pushTo(PAGES.COURT_MANAGER_ASSIGNED_CLAIM)();
    }
  };

  return (
    <RefusalDialogWrapper
      className="refusal-content"
      handleValidate={handleValidation}
      handleClose={
        /* istanbul ignore next */ () => props.setIsRejectionDialogOpen(false)
      }
      title={translate(messages.courtManagerRefuseDialogTitle, props)}
      cancelTitle={translate(
        messages.courtManagerRefusalDialogReasonCancel,
        props,
      )}
      confirmTitle={translate(
        messages.courtManagerRefusalDialogReasonValidate,
        props,
      )}
      open={props.isRejectionDialogOpen}
      validateButtonDisabled={!rejectionReason}
    >
      <div className="reason-wrapper">
        <TextField
          id="judgement-on-merits-rejection-reason"
          label={translate(
            messages.courtManagerRefusalDialogReasonLabel,
            props,
          )}
          onChange={handleChangeRejectionReason}
          value={rejectionReason}
          fullWidth
        />
      </div>
    </RefusalDialogWrapper>
  );
};

export default injectIntl(RejectionDialog);
